import apiClient from './apiClient';

export const createRazorpayOrder = async (planId) => {
  const { data } = await apiClient.post('/api/payments/razorpay/order', { planId });
  return data;
};

export const verifyRazorpayPayment = async (payload) => {
  const { data } = await apiClient.post('/api/payments/razorpay/verify', payload);
  return data;
};

export const createCourseRazorpayOrder = async (courseId) => {
  const { data } = await apiClient.post('/api/payments/razorpay/course-order', { courseId });
  return data;
};

export const verifyCourseRazorpayPayment = async (payload) => {
  const { data } = await apiClient.post('/api/payments/razorpay/course-verify', payload);
  return data;
};

export const getMyPaymentHistory = async () => {
  const { data } = await apiClient.get('/api/payments/history');
  return Array.isArray(data) ? data : [];
};

export const getMyCoursePurchases = async () => {
  const { data } = await apiClient.get('/api/payments/course-purchases');
  return {
    purchasedCourseIds: Array.isArray(data?.purchasedCourseIds)
      ? data.purchasedCourseIds.map(String)
      : [],
    purchases: Array.isArray(data?.purchases) ? data.purchases : [],
  };
};
